import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup.object({
  password_api: yup
    .string()
    .min(6, 'New Password must be at least 6 characters')
    .required('Password is required'),
})

const resChangePassword = yupResolver(schema)

export default resChangePassword
